// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../../shared/src/IOUtils.bs.js");
var ReactIO = require("../../../shared/src/ReactIO.bs.js");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var Reselect = require("../../../shared/src/bindings/Reselect.bs.js");
var WebStore = require("../store/WebStore.bs.js");
var MathUtils = require("../../../shared/src/MathUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var WebEnvVars = require("../WebEnvVars.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var WebTypes_Shift = require("../types/WebTypes_Shift.bs.js");
var WebGraphql_Shifts = require("../graphql/WebGraphql_Shifts.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var WebStore_Selectors = require("../store/WebStore_Selectors.bs.js");
var FormalityCompat__Form = require("re-formality/src/FormalityCompat__Form.bs.js");
var WebStore_Types_Action = require("../store/WebStore_Types_Action.bs.js");
var BrowserComponents_Text = require("../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var CommonTypes_PhoneNumber = require("../../../shared/src/types/CommonTypes_PhoneNumber.bs.js");
var BrowserComponents_Spacer = require("../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_Loading = require("../../../shared-browser/src/components/BrowserComponents_Loading.bs.js");
var BrowserComponents_InfoCard = require("../../../shared-browser/src/components/BrowserComponents_InfoCard.bs.js");
var CommonTypes_LongPhoneNumber = require("../../../shared/src/types/CommonTypes_LongPhoneNumber.bs.js");
var CommonTypes_Shift_Accessory = require("../../../shared/src/types/CommonTypes_Shift_Accessory.bs.js");
var BrowserComponents_FlexColumn = require("../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var WebComponents_PostAShiftForm = require("../components/WebComponents_PostAShiftForm.bs.js");
var WebComponents_ProgressHeader = require("../components/WebComponents_ProgressHeader.bs.js");
var FormalityCompat__PublicHelpers = require("re-formality/src/FormalityCompat__PublicHelpers.bs.js");
var CommonTypes_ShiftType_Accessory = require("../../../shared/src/types/CommonTypes_ShiftType_Accessory.bs.js");
var CommonTypes_Shift_OnsiteManager = require("../../../shared/src/types/CommonTypes_Shift_OnsiteManager.bs.js");
var BrowserComponents_ValidationError = require("../../../shared-browser/src/components/BrowserComponents_ValidationError.bs.js");
var WebComponents_ProfessionalShiftPreview = require("../components/WebComponents_ProfessionalShiftPreview.bs.js");

var googleMapsToken = WebEnvVars.vars.googleMapsWebClientApiToken;

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display("flex"),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: {
          hd: BrowserStyle.flexDirection(BrowserStyle.row),
          tl: {
            hd: BrowserStyle.flexWrap(BrowserStyle.nowrap),
            tl: /* [] */0
          }
        }
      }
    });

var wrapper = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* XLarge */5, undefined)({
          hd: BrowserStyle.display("flex"),
          tl: {
            hd: BrowserStyle.flex({
                  NAME: "num",
                  VAL: 1.0
                }),
            tl: {
              hd: BrowserStyle.flexDirection(BrowserStyle.column),
              tl: {
                hd: BrowserStyle.flexWrap(BrowserStyle.nowrap),
                tl: {
                  hd: BrowserStyle.minHeight(BrowserStyle.zero),
                  tl: /* [] */0
                }
              }
            }
          }
        }));

var leftContent = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems("center"),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: {
          hd: BrowserStyle.flexBasis(BrowserStyle.pct(60.0)),
          tl: {
            hd: BrowserStyle.mobileMedia({
                  hd: BrowserStyle.flexBasis(BrowserStyle.pct(100.0)),
                  tl: {
                    hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
                    tl: /* [] */0
                  }
                }),
            tl: {
              hd: BrowserStyle.padding2(BrowserStyle.Spacing.large, BrowserStyle.Spacing.xxLarge),
              tl: /* [] */0
            }
          }
        }
      }
    });

var rightContent = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.backgroundColor({
            TAG: /* White */7,
            _0: /* Medium */1
          }),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: {
          hd: BrowserStyle.flexBasis(BrowserStyle.pct(40.0)),
          tl: {
            hd: BrowserStyle.mobileMedia({
                  hd: BrowserStyle.display("none"),
                  tl: /* [] */0
                }),
            tl: /* [] */0
          }
        }
      }
    });

var cannotEditShiftText = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.textAlign(BrowserStyle.center),
      tl: /* [] */0
    });

var Styles = {
  container: container,
  wrapper: wrapper,
  leftContent: leftContent,
  rightContent: rightContent,
  cannotEditShiftText: cannotEditShiftText
};

function initialState(param) {
  var originalNumberOfWorkers = param.originalNumberOfWorkers;
  var match = param.onsiteManager;
  var hourlyRateCents = param.hourlyRateCents;
  return {
          description: param.description,
          dressCode: param.dressCode,
          hourlyRateCents: hourlyRateCents,
          numberOfWorkers: originalNumberOfWorkers,
          onsiteManagerName: match.name,
          onsiteManagerPhoneNumber: CommonTypes_LongPhoneNumber.toFormattedString(match.phoneNumber),
          parkingCost: param.parkingCost,
          parkingInstructions: param.parkingInstructions,
          previousHourlyRateCents: hourlyRateCents,
          previousNumberOfWorkers: originalNumberOfWorkers
        };
}

function get(param) {
  return param.numberOfWorkers;
}

function update(setState, state, numberOfWorkers) {
  return Curry._2(setState, /* NumberOfWorkers */0, {
              description: state.description,
              dressCode: state.dressCode,
              hourlyRateCents: state.hourlyRateCents,
              numberOfWorkers: numberOfWorkers,
              onsiteManagerName: state.onsiteManagerName,
              onsiteManagerPhoneNumber: state.onsiteManagerPhoneNumber,
              parkingCost: state.parkingCost,
              parkingInstructions: state.parkingInstructions,
              previousHourlyRateCents: state.previousHourlyRateCents,
              previousNumberOfWorkers: state.previousNumberOfWorkers
            });
}

function validator_validate(param) {
  if (Curry._2(Relude_Int.greaterThanOrEq, param.numberOfWorkers, param.previousNumberOfWorkers)) {
    return Relude_Result.ok(/* Valid */0);
  } else {
    return Relude_Result.error("You can't decrease the amount of Professionals");
  }
}

var validator = {
  field: /* NumberOfWorkers */0,
  strategy: /* OnFirstBlur */0,
  dependents: undefined,
  validate: validator_validate
};

var NumberOfWorkersField = {
  get: get,
  update: update,
  validator: validator
};

function get$1(param) {
  return param.parkingInstructions;
}

function update$1(setState, state, parkingInstructions) {
  return Curry._2(setState, /* ParkingInstructions */2, {
              description: state.description,
              dressCode: state.dressCode,
              hourlyRateCents: state.hourlyRateCents,
              numberOfWorkers: state.numberOfWorkers,
              onsiteManagerName: state.onsiteManagerName,
              onsiteManagerPhoneNumber: state.onsiteManagerPhoneNumber,
              parkingCost: state.parkingCost,
              parkingInstructions: parkingInstructions,
              previousHourlyRateCents: state.previousHourlyRateCents,
              previousNumberOfWorkers: state.previousNumberOfWorkers
            });
}

function validator_validate$1(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(get$1, Relude_String.toNonWhitespace, param);
                            }), (function (param) {
                              return Relude_Option.map((function (param) {
                                            return Relude_Globals.$$const(/* Valid */0, param);
                                          }), param);
                            }), param);
              }), (function (param) {
                return Relude_Result.fromOption("Must have arrival instructions", param);
              }), param);
}

var validator$1 = {
  field: /* ParkingInstructions */2,
  strategy: /* OnFirstBlur */0,
  dependents: undefined,
  validate: validator_validate$1
};

var ParkingInstructionsField = {
  get: get$1,
  update: update$1,
  validator: validator$1
};

function get$2(param) {
  return param.onsiteManagerName;
}

function update$2(setState, state, onsiteManagerName) {
  return Curry._2(setState, /* OnsiteManagerName */3, {
              description: state.description,
              dressCode: state.dressCode,
              hourlyRateCents: state.hourlyRateCents,
              numberOfWorkers: state.numberOfWorkers,
              onsiteManagerName: onsiteManagerName,
              onsiteManagerPhoneNumber: state.onsiteManagerPhoneNumber,
              parkingCost: state.parkingCost,
              parkingInstructions: state.parkingInstructions,
              previousHourlyRateCents: state.previousHourlyRateCents,
              previousNumberOfWorkers: state.previousNumberOfWorkers
            });
}

function validator_validate$2(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(get$2, Relude_String.toNonWhitespace, param);
                            }), (function (param) {
                              return Relude_Option.map((function (param) {
                                            return Relude_Globals.$$const(/* Valid */0, param);
                                          }), param);
                            }), param);
              }), (function (param) {
                return Relude_Result.fromOption("Enter a onsite manager name", param);
              }), param);
}

var validator$2 = {
  field: /* OnsiteManagerName */3,
  strategy: /* OnFirstBlur */0,
  dependents: undefined,
  validate: validator_validate$2
};

var OnsiteManagerNameField = {
  get: get$2,
  update: update$2,
  validator: validator$2
};

function get$3(param) {
  return param.onsiteManagerPhoneNumber;
}

function update$3(setState, state, onsiteManagerPhoneNumber) {
  return Curry._2(setState, /* OnsiteManagerPhoneNumber */4, {
              description: state.description,
              dressCode: state.dressCode,
              hourlyRateCents: state.hourlyRateCents,
              numberOfWorkers: state.numberOfWorkers,
              onsiteManagerName: state.onsiteManagerName,
              onsiteManagerPhoneNumber: onsiteManagerPhoneNumber,
              parkingCost: state.parkingCost,
              parkingInstructions: state.parkingInstructions,
              previousHourlyRateCents: state.previousHourlyRateCents,
              previousNumberOfWorkers: state.previousNumberOfWorkers
            });
}

var invalidPhoneMessage = "Enter a valid phone number";

function validator_validate$3(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(get$3, CommonTypes_PhoneNumber.fromString, param);
                            }), (function (param) {
                              return Relude_Option.map((function (param) {
                                            return Relude_Globals.$$const(/* Valid */0, param);
                                          }), param);
                            }), param);
              }), (function (param) {
                return Relude_Result.fromOption(invalidPhoneMessage, param);
              }), param);
}

var validator$3 = {
  field: /* OnsiteManagerPhoneNumber */4,
  strategy: /* OnFirstChange */1,
  dependents: undefined,
  validate: validator_validate$3
};

var OnsiteManagerPhoneNumberField = {
  get: get$3,
  update: update$3,
  invalidPhoneMessage: invalidPhoneMessage,
  validator: validator$3
};

function get$4(param) {
  return param.description;
}

function update$4(setState, state, description) {
  return Curry._2(setState, /* Description */5, {
              description: description,
              dressCode: state.dressCode,
              hourlyRateCents: state.hourlyRateCents,
              numberOfWorkers: state.numberOfWorkers,
              onsiteManagerName: state.onsiteManagerName,
              onsiteManagerPhoneNumber: state.onsiteManagerPhoneNumber,
              parkingCost: state.parkingCost,
              parkingInstructions: state.parkingInstructions,
              previousHourlyRateCents: state.previousHourlyRateCents,
              previousNumberOfWorkers: state.previousNumberOfWorkers
            });
}

function validator_validate$4(param) {
  return Relude_Result.fromOption("You must have a shift description", Relude_Option.map((function (param) {
                    return Relude_Globals.$$const(/* Valid */0, param);
                  }), Relude_String.toNonWhitespace(param.description)));
}

var validator$4 = {
  field: /* Description */5,
  strategy: /* OnFirstBlur */0,
  dependents: undefined,
  validate: validator_validate$4
};

var DescriptionField = {
  get: get$4,
  update: update$4,
  validator: validator$4
};

function get$5(param) {
  return param.hourlyRateCents;
}

function update$5(setState, state, hourlyRateCents) {
  return Curry._2(setState, /* HourlyRate */6, {
              description: state.description,
              dressCode: state.dressCode,
              hourlyRateCents: hourlyRateCents,
              numberOfWorkers: state.numberOfWorkers,
              onsiteManagerName: state.onsiteManagerName,
              onsiteManagerPhoneNumber: state.onsiteManagerPhoneNumber,
              parkingCost: state.parkingCost,
              parkingInstructions: state.parkingInstructions,
              previousHourlyRateCents: state.previousHourlyRateCents,
              previousNumberOfWorkers: state.previousNumberOfWorkers
            });
}

function validator_validate$5(param) {
  var previousHourlyRateCents = param.previousHourlyRateCents;
  if (param.hourlyRateCents >= previousHourlyRateCents) {
    return Relude_Result.ok(/* Valid */0);
  } else {
    return {
            TAG: /* Error */1,
            _0: "You cannot lower the hourly rate, must be at least " + MathUtils.formatCentsToMoney(previousHourlyRateCents)
          };
  }
}

var validator$5 = {
  field: /* HourlyRate */6,
  strategy: /* OnFirstBlur */0,
  dependents: undefined,
  validate: validator_validate$5
};

var HourlyRateField = {
  get: get$5,
  update: update$5,
  validator: validator$5
};

var validators_1 = {
  hd: validator$1,
  tl: {
    hd: validator$2,
    tl: {
      hd: validator$3,
      tl: {
        hd: validator$4,
        tl: {
          hd: validator$5,
          tl: /* [] */0
        }
      }
    }
  }
};

var validators = {
  hd: validator,
  tl: validators_1
};

var Form = {
  initialState: initialState,
  NumberOfWorkersField: NumberOfWorkersField,
  ParkingInstructionsField: ParkingInstructionsField,
  OnsiteManagerNameField: OnsiteManagerNameField,
  OnsiteManagerPhoneNumberField: OnsiteManagerPhoneNumberField,
  DescriptionField: DescriptionField,
  HourlyRateField: HourlyRateField,
  validators: validators
};

var FormContainer = FormalityCompat__Form.Make({
      validators: validators
    });

function WebContainers_EditShift$Content(Props) {
  var currentDatetime = Props.currentDatetime;
  var editShift = Props.editShift;
  var fetchGeocodeForAddress = Props.fetchGeocodeForAddress;
  var markupRate = Props.markupRate;
  var setView = Props.setView;
  var shift = Props.shift;
  var match = shift.location;
  var address = match.address;
  var match$1 = ReactIO.useState(function (param) {
        
      });
  var setGeocode = match$1[1];
  ReactIO.useEffect1(undefined, undefined, (function (param) {
          return Relude_Globals.$great$great(fetchGeocodeForAddress, (function (param) {
                        return Relude_IO.flatMap((function (param) {
                                      return Relude_Globals.$great$great(Relude_Option.pure, setGeocode, param);
                                    }), param);
                      }), param);
        }), address);
  var match$2 = Curry._2(FormContainer.useForm, initialState(shift), (function (param, param$1) {
          var newrecord = Caml_obj.caml_obj_dup(shift);
          return IOUtils.unsafeRunHandledAsync(Curry._1(editShift, (newrecord.parkingInstructions = param.parkingInstructions, newrecord.parkingCost = param.parkingCost, newrecord.onsiteManager = CommonTypes_Shift_OnsiteManager.make(param.onsiteManagerName, Relude_Option.getOrElse(CommonTypes_LongPhoneNumber.$$default, CommonTypes_LongPhoneNumber.fromString(param.onsiteManagerPhoneNumber))), newrecord.numberOfWorkers = param.numberOfWorkers, newrecord.hourlyRateCents = param.hourlyRateCents, newrecord.dressCode = param.dressCode, newrecord.description = param.description, newrecord)));
        }));
  var submit = match$2.submit;
  var blur = match$2.blur;
  var change = match$2.change;
  var result = match$2.result;
  var state = match$2.state;
  var parkingInstructions = state.parkingInstructions;
  var hourlyRateCents = state.hourlyRateCents;
  var description = state.description;
  var x = Relude_Int.toFloat(hourlyRateCents);
  var info = [
    {
      content: String(state.numberOfWorkers),
      displayContent: undefined,
      extraContent: undefined,
      inputType: /* NumberInt */1,
      onBlur: Relude_IO.suspend(function (param) {
            return Curry._1(blur, /* NumberOfWorkers */0);
          }),
      onChange: (function (param) {
          return Relude_Globals.$great$great((function (param) {
                        return Relude_Globals.$great$great(Relude_Int.fromString, Relude_IO.pure, param);
                      }), (function (param) {
                        return Relude_IO.map((function (param) {
                                      return Relude_Option.fold(undefined, (function (param) {
                                                    return update(change, state, param);
                                                  }), param);
                                    }), param);
                      }), param);
        }),
      title: "Professionals"
    },
    {
      content: Relude_Float.toString(MathUtils.centsToDollars(hourlyRateCents)),
      displayContent: Relude_Option.pure(MathUtils.formatCentsToMoney(hourlyRateCents)),
      extraContent: "(You pay " + (MathUtils.formatMoney(x * markupRate / 100.0) + "/hr)"),
      inputType: /* NumberInt */1,
      onBlur: Relude_IO.suspend(function (param) {
            return Curry._1(blur, /* HourlyRate */6);
          }),
      onChange: (function (param) {
          return Relude_Globals.$great$great((function (param) {
                        return Relude_Globals.$great$great(Relude_Float.fromString, Relude_IO.pure, param);
                      }), (function (param) {
                        return Relude_IO.map((function (param) {
                                      return Relude_Globals.$great$great((function (param) {
                                                    return Relude_Option.fold(0, MathUtils.dollarsToCents, param);
                                                  }), (function (param) {
                                                    return update$5(change, state, param);
                                                  }), param);
                                    }), param);
                      }), param);
        }),
      title: "Hourly Rate"
    },
    {
      content: state.onsiteManagerName,
      displayContent: undefined,
      extraContent: undefined,
      inputType: /* Text */2,
      onBlur: Relude_IO.suspend(function (param) {
            return Curry._1(blur, /* OnsiteManagerName */3);
          }),
      onChange: (function (param) {
          return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                        return Relude_IO.map((function (param) {
                                      return update$2(change, state, param);
                                    }), param);
                      }), param);
        }),
      title: "Manager Name"
    },
    {
      content: state.onsiteManagerPhoneNumber,
      displayContent: undefined,
      extraContent: undefined,
      inputType: /* Text */2,
      onBlur: Relude_IO.suspend(function (param) {
            return Curry._1(blur, /* OnsiteManagerPhoneNumber */4);
          }),
      onChange: (function (param) {
          return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                        return Relude_IO.map((function (param) {
                                      return update$3(change, state, param);
                                    }), param);
                      }), param);
        }),
      title: "Manager Contact"
    },
    {
      content: description,
      displayContent: undefined,
      extraContent: undefined,
      inputType: /* Text */2,
      onBlur: Relude_IO.suspend(function (param) {
            return Curry._1(blur, /* Description */5);
          }),
      onChange: (function (param) {
          return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                        return Relude_IO.map((function (param) {
                                      return update$4(change, state, param);
                                    }), param);
                      }), param);
        }),
      title: "Description"
    },
    {
      content: parkingInstructions,
      displayContent: undefined,
      extraContent: undefined,
      inputType: /* Text */2,
      onBlur: Relude_IO.suspend(function (param) {
            return Curry._1(blur, /* ParkingInstructions */2);
          }),
      onChange: (function (param) {
          return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                        return Relude_IO.map((function (param) {
                                      return update$1(change, state, param);
                                    }), param);
                      }), param);
        }),
      title: "Arrival Instructions"
    }
  ];
  var canEditShift = WebTypes_Shift.canBusinessEditShift(currentDatetime, shift);
  var tmp = {
    accessories: Curry._1(CommonTypes_ShiftType_Accessory.$$Set.toArray, CommonTypes_Shift_Accessory.toShiftTypeAccessorySet(shift.accessories)),
    address: address,
    attire: shift.attire,
    className: rightContent,
    description: description,
    dressCode: state.dressCode,
    endDatetime: shift.endDatetime,
    googleMapsToken: googleMapsToken,
    hourlyRateCents: hourlyRateCents,
    locationName: match.name,
    onsiteManager: shift.onsiteManager,
    parkingCost: state.parkingCost,
    parkingInstructions: parkingInstructions,
    shiftType: shift.shiftType,
    startDatetime: shift.startDatetime,
    timezone: shift.timezone,
    tipsPayoutType: shift.tipsPayoutType
  };
  var tmp$1 = Relude_Option.map((function (param) {
          return param.geocode;
        }), match$1[0]);
  if (tmp$1 !== undefined) {
    tmp.geocode = Caml_option.valFromOption(tmp$1);
  }
  return React.createElement("main", {
              className: wrapper
            }, React.createElement(WebComponents_ProgressHeader.Plain.make, {
                  onCancel: Curry._1(setView, {
                        TAG: /* BusinessDashboard */0,
                        _0: {
                          TAG: /* ShiftsList */1,
                          _0: /* Upcoming */1
                        }
                      })
                }), React.createElement("form", {
                  className: container,
                  onSubmit: (function (param) {
                      return FormalityCompat__PublicHelpers.Dom.preventDefault(submit, param);
                    })
                }, React.createElement(BrowserComponents_FlexColumn.make, {
                      className: leftContent,
                      children: null
                    }, React.createElement(WebComponents_PostAShiftForm.Title.make, {
                          subtitle: "Need to make a change?",
                          title: "Edit Shift"
                        }), canEditShift ? React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_InfoCard.Editable.make, {
                                info: info
                              }), React.createElement(BrowserComponents_ValidationError.make, {
                                validationResult: Curry._1(result, /* NumberOfWorkers */0)
                              }), React.createElement(BrowserComponents_ValidationError.make, {
                                validationResult: Curry._1(result, /* OnsiteManagerName */3)
                              }), React.createElement(BrowserComponents_ValidationError.make, {
                                validationResult: Curry._1(result, /* OnsiteManagerPhoneNumber */4)
                              }), React.createElement(BrowserComponents_ValidationError.make, {
                                validationResult: Curry._1(result, /* Description */5)
                              }), React.createElement(BrowserComponents_ValidationError.make, {
                                validationResult: Curry._1(result, /* ParkingInstructions */2)
                              }), React.createElement(BrowserComponents_ValidationError.make, {
                                validationResult: Curry._1(result, /* HourlyRate */6)
                              })) : React.createElement(BrowserComponents_Text.make, {
                            className: cannotEditShiftText,
                            children: "Changes to this shift cannot be made close to or after the start time. Please reach out to our support team at 79425 if you still need to make changes."
                          }), React.createElement(BrowserComponents_Spacer.make, {
                          size: /* XLarge */6
                        }), React.createElement(WebComponents_PostAShiftForm.Buttons.make, {
                          onBackButtonClick: Curry._1(setView, {
                                TAG: /* BusinessDashboard */0,
                                _0: {
                                  TAG: /* ShiftsList */1,
                                  _0: /* Upcoming */1
                                }
                              }),
                          submitButtonDisabled: !canEditShift,
                          submitButtonTitle: "Edit Shift"
                        })), React.createElement(WebComponents_ProfessionalShiftPreview.make, tmp)));
}

var Content = {
  make: WebContainers_EditShift$Content
};

function WebContainers_EditShift$Presentation(Props) {
  var currentDatetime = Props.currentDatetime;
  var editShift = Props.editShift;
  var editShiftId = Props.editShiftId;
  var fetchEditingShift = Props.fetchEditingShift;
  var fetchGeocodeForAddress = Props.fetchGeocodeForAddress;
  var markupRate = Props.markupRate;
  var setView = Props.setView;
  var shift = Props.shift;
  ReactIO.useHandledIOOnMount(undefined)(Curry._1(fetchEditingShift, editShiftId));
  var partial_arg = React.createElement(BrowserComponents_Loading.make, {});
  return Relude_AsyncResult.foldByValue(React.createElement(BrowserComponents_Loading.make, {}), (function (shift) {
                return React.createElement(WebContainers_EditShift$Content, {
                            currentDatetime: currentDatetime,
                            editShift: editShift,
                            fetchGeocodeForAddress: fetchGeocodeForAddress,
                            markupRate: markupRate,
                            setView: setView,
                            shift: shift
                          });
              }), (function (param) {
                return Relude_Globals.$$const(partial_arg, param);
              }), shift);
}

var Presentation = {
  make: WebContainers_EditShift$Presentation
};

var mapStateToProps = Reselect.createSelector3(undefined, WebStore_Selectors.getAuthorizedClient, WebStore_Selectors.getTimeEveryFiveMinutes, (function (param) {
        return param.editingShift;
      }), (function (authorizedClient, currentDatetime, shift) {
        return {
                authorizedClient: authorizedClient,
                currentDatetime: currentDatetime,
                shift: shift
              };
      }));

function mapDispatchToProps(dispatch, param) {
  var authorizedClient = param.authorizedClient;
  var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
          
        }));
  return {
          editShift: (function (shift) {
              var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
                      
                    }));
              var partial_arg$1 = Curry._1(WebGraphql_Shifts.EditShift.mutate, shift);
              var partial_arg$2 = function (param) {
                return Relude_Globals.$great$great(partial_arg$1, partial_arg, param);
              };
              return Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(partial_arg$2, (function (param) {
                                          return Relude_IO.flatMap((function (param) {
                                                        return Curry._2(Relude_IO.mapError, (function (prim) {
                                                                      
                                                                    }), Curry._1(dispatch, WebStore_Types_Action.setView({
                                                                            TAG: /* BusinessDashboard */0,
                                                                            _0: {
                                                                              TAG: /* ShiftsList */1,
                                                                              _0: /* Upcoming */1
                                                                            }
                                                                          })));
                                                      }), param);
                                        }), param);
                          }), Relude_IO.fromOption((function (prim) {
                                
                              }), authorizedClient));
            }),
          fetchEditingShift: (function (shiftId) {
              return Curry._2(Relude_IO.mapError, (function (prim) {
                            
                          }), Relude_IO.flatMap((function (param) {
                                return Curry._1(dispatch, WebStore_Types_Action.fetchUser);
                              }), Curry._1(dispatch, WebStore_Types_Action.fetchEditingShift(shiftId))));
            }),
          fetchGeocodeForAddress: (function (address) {
              var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
                      
                    }));
              var partial_arg$1 = Curry._1(WebGraphql_Shifts.GeocodeAddress.query, address);
              return Curry._2(Relude_IO.mapError, (function (prim) {
                            
                          }), Relude_IO.flatMap((function (param) {
                                return Relude_Globals.$great$great(partial_arg$1, partial_arg, param);
                              }), Relude_IO.fromOption((function (prim) {
                                    
                                  }), authorizedClient)));
            }),
          setView: (function (param) {
              return Relude_Globals.$great$great((function (param) {
                            return Relude_Globals.$great$great(WebStore_Types_Action.setView, dispatch, param);
                          }), partial_arg, param);
            })
        };
}

function WebContainers_EditShift(Props) {
  var editShiftId = Props.editShiftId;
  var param = Props.user;
  var markupRate = param.business.markupRate;
  return React.createElement(WebStore.Provider.make, {
              mapStateToProps: mapStateToProps,
              mapDispatchToProps: mapDispatchToProps,
              children: (function (param, param$1) {
                  return React.createElement(WebContainers_EditShift$Presentation, {
                              currentDatetime: param.currentDatetime,
                              editShift: param$1.editShift,
                              editShiftId: editShiftId,
                              fetchEditingShift: param$1.fetchEditingShift,
                              fetchGeocodeForAddress: param$1.fetchGeocodeForAddress,
                              markupRate: markupRate + 1.0,
                              setView: param$1.setView,
                              shift: param.shift
                            });
                })
            });
}

var make = WebContainers_EditShift;

exports.googleMapsToken = googleMapsToken;
exports.Styles = Styles;
exports.Form = Form;
exports.FormContainer = FormContainer;
exports.Content = Content;
exports.Presentation = Presentation;
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;
exports.make = make;
/* container Not a pure module */
